import SmsTable from './sms-table';

export default SmsTable;
